export const gtmInitialize = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'})
  }

export const gtmPush = (payload) => {
window.dataLayer = window.dataLayer || []
window.dataLayer.push(payload)
}
